export default __webpack_public_path__ + "static/sanctuary-homepage-banner-1-desktop-99516809a439d72c2ebcadb7c58dfb2a.webp";